import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useCreateBreadCrumbs } from '../../hooks';
import Details from '../../components/reservation/details';
import { useTranslation } from 'react-i18next';
//import './reservation-detail.css';

const ReservationDetails = ({ isFromReview = false }) => {
  const { id, orgId, userId } = useParams();
  const location = useLocation();
  const { t } = useTranslation('translation', {
    keyPrefix: 'screens.details.reservation.breadcrumbs',
  });
  const { t: tGeneric } = useTranslation();
  const isFromDispute = location?.pathname?.includes('/disputes/reservation');
  const isFromRefunds = location?.pathname?.includes('/refunds/reservation');
  const isFromMonitor = location?.pathname?.includes('/transactions/reservation');
  const isFromCompensations = location?.pathname?.includes('/accounts/reservation');
  const isFromSeller = location?.pathname?.includes('/profile/');
  const isFromAffiliates = location?.pathname?.includes('/affiliates/');
  const isFromInternal = location?.pathname?.includes('/internalStaff/');
  const isFromReviewUrl = location?.pathname?.includes('-review');

  const crumbs = isFromReviewUrl
    ? [
        {
          name: t('prevReview'),
          path: '/reservation-review',
        },
        {
          name: t('current'),
        },
      ]
    : isFromInternal
    ? [
        { name: tGeneric('components.sideBar.internalStaff'), path: '/internalStaff' },
        {
          name: tGeneric('screens.profile.breadcrumbsConcierges', {
            concierge: tGeneric('generic.internal_staff'),
          }),
          path: `/internalStaff/${orgId}/${userId}/profile?tab=RESERVATION`,
        },
        { name: t('current') },
      ]
    : isFromAffiliates
    ? [
        { name: tGeneric('components.sideBar.affiliates'), path: '/affiliates' },
        {
          name: tGeneric('screens.profile.breadcrumbsConcierges', {
            concierge: tGeneric('generic.affiliate'),
          }),
          path: `/affiliates/${orgId}/${userId}/profile?tab=RESERVATION`,
        },
        { name: t('current') },
      ]
    : isFromSeller
    ? [
        { name: tGeneric('screens.concierges.title'), path: '/sellers' },
        {
          name: tGeneric('screens.profile.breadcrumbsConcierges', {
            concierge: tGeneric('generic.concierge'),
          }),
          path: `/sellers/${orgId}/${userId}/profile?tab=RESERVATION`,
        },
        { name: t('current') },
      ]
    : [
        {
          name: isFromDispute
            ? t('prevDispute')
            : isFromRefunds
            ? t('prevRefund')
            : isFromMonitor
            ? t('prevMonitor')
            : isFromCompensations
            ? t('prevCompensation')
            : t('prev'),
          path: isFromDispute
            ? '/disputes'
            : isFromRefunds
            ? '/refunds'
            : isFromMonitor
            ? '/transactions'
            : isFromCompensations
            ? '/accounts'
            : '/reservation-history',
        },
        {
          name: t('current'),
        },
      ];
  useCreateBreadCrumbs(crumbs);

  return <Details id={id} mode={'reservation'} isFromReview={isFromReview} />;
};

export default ReservationDetails;
